import React from 'react';
import moment from 'moment';
import { TAnnex6V2Record } from '../../../../../../../redux/app/annex6-v2/@types';
import { TAnnex6V2GroupB3 } from '../../../../../../../redux/app/annex6-v2/groups/group-b';
import Annex6V2TableRows from '../../_elements_v2/Annex6V2TableRows';

type OwnProps = {
    annex6V2Record: TAnnex6V2Record;
    isStrikedOff?: boolean;
    theme?: 'light' | 'dark';
};
type Annex6V2GroupB3PreviewProps = OwnProps;

function Annex6V2GroupB3Preview(props: Annex6V2GroupB3PreviewProps) {
    const record = props.annex6V2Record as TAnnex6V2GroupB3;
    const operationDate = moment(record.selectedDate, 'YYYY-MM-DD').format(
        'DD-MMM-YYYY'
    );
    const { itemB3P1, itemB3P2 } = record;

    function renderMain() {
        const tableRows = [];

        if (itemB3P1.recordEngine && itemB3P1.recordEngine.length > 1) {
            tableRows.push([operationDate, 'B', '1.3', renderItemB3P1()]);
        }

        if (itemB3P2.recordEngine && itemB3P2.recordEngine.length > 1) {
            tableRows.push([null, null, '2', renderItemB3P2()]);
        }

        if (record.remarks) {
            tableRows.push([null, null, 'NOTE', record.remarks]);
        }

        return (
            <Annex6V2TableRows
                record={record}
                tableRows={tableRows}
                theme={props.theme}
            />
        );
    }

    function renderItemB3P1() {
        const { date: smtDate, time: smtTime } = record.itemB3P1.engineStart;
        const { latitude, longitude } = record.itemB3P1.startPosition;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);

        return (
            <h4 className="font-medium uppercase">
                {record.itemB3P1.recordEngine} started on{' '}
                {utcTime.format('HH:mm')} hrs UTC on{' '}
                {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}) at{' '}
                {latitude} | {longitude}
            </h4>
        );
    }

    function renderItemB3P2() {
        const { date: smtDate, time: smtTime } = record.itemB3P2.engineStop;
        const { latitude, longitude } = record.itemB3P2.stopPosition;
        const dateTimeLocal = `${smtDate}T${smtTime}:00${record.timeZone}`;
        const utcTime = moment.utc(dateTimeLocal);

        return (
            <h4 className="font-medium uppercase">
                {record.itemB3P2.recordEngine} stopped on{' '}
                {utcTime.format('HH:mm')} hrs UTC on{' '}
                {utcTime.format('DD-MMM-YYYY')} ({smtTime} SMT on{' '}
                {moment(smtDate, 'YYYY-MM-DD').format('DD-MMM-YYYY')}) at{' '}
                {latitude} | {longitude}
            </h4>
        );
    }

    return renderMain();
}

export default Annex6V2GroupB3Preview;
